const SectionTemplateStageApplicability = {
    PROPOSAL: 0,
    BINDER: 1,
    BOTH: 2
};

angular.module('ums.configuration')
    .constant('sectionTemplateStageApplicability', SectionTemplateStageApplicability);
